"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _checkboxChecked = _interopRequireDefault(require("cccisd-icons/svg/checkbox-checked2"));
var _checkboxPartial = _interopRequireDefault(require("cccisd-icons/svg/checkbox-partial2"));
var _checkboxUnchecked = _interopRequireDefault(require("cccisd-icons/svg/checkbox-unchecked2"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MultiCheckbox = function MultiCheckbox(_ref) {
  var options = _ref.options,
    field = _ref.field,
    form = _ref.form,
    isSingle = _ref.isSingle;
  var isAllSelected = field.value.length === options.length;
  var toggleAll = function toggleAll() {
    var newSelected = !isAllSelected || isSingle ? options.map(function (item) {
      return item.value;
    }) : [];
    form.setFieldValue(field.name, newSelected);
  };
  var icon = function icon() {
    if (isAllSelected) {
      return /*#__PURE__*/_react["default"].createElement(_checkboxChecked["default"], null);
    }
    if (field.value.length > 0) {
      return /*#__PURE__*/_react["default"].createElement(_checkboxPartial["default"], null);
    }
    return /*#__PURE__*/_react["default"].createElement(_checkboxUnchecked["default"], null);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].group
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].check,
    onClick: toggleAll
  }, icon()), /*#__PURE__*/_react["default"].createElement("label", {
    onClick: toggleAll
  }, "Clear all progress and metrics"), !isSingle && /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].count
  }, "(", field.value.length, "/", options.length, ")")), !isSingle && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].listWrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].list
  }, options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: option.value,
      className: "checkbox",
      style: {
        margin: 0
      }
    }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
      type: "checkbox",
      onChange: function onChange() {
        form.setFieldValue(field.name, (0, _xor2["default"])(field.value, [option.value]));
      },
      checked: field.value.includes(option.value)
    }), ' ', "Clear progress for survey: ", /*#__PURE__*/_react["default"].createElement("strong", null, option.label)));
  })), field.name in form.errors && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-danger",
    style: {
      marginTop: '0.3em'
    }
  }, form.errors[field.name])));
};
MultiCheckbox.propTypes = {
  field: _propTypes["default"].object,
  form: _propTypes["default"].object,
  options: _propTypes["default"].array,
  isSingle: _propTypes["default"].bool
};
var _default = exports["default"] = MultiCheckbox;